module.exports = (__webpack_require__(7304))(878);